module.exports = __webpack_public_path__ + "images/logos/logo-supergoop-rich-67fbcb74b16b7d13cc3df71a645aa91f.webp";